//#region import
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusFinalScore, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { ApiProject } from 'enum/api';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import _ from "lodash";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ModalScoringCriteria from '../components/Modal/ModalScoringCriteria';
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ProjectScoreSummary = () => { //สรุปคะแนน
    const { 
        nProjectID,
        isFastTrack,
        isPermission,
        nStatusID,
        sMode,
        setisBtnScoreSummary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();

    //#region useState
    const [ObjDataProject, setObjDataProject] = useState(null);
    const [nTotalScore, setnTotalScore] = useState(null); //คะแนนที่ได้ All
    const [nTotalWeightScore, setnTotalWeightScore] = useState(null); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All
    const [isPassCriteriaScore, setisPassCriteriaScore] = useState(null); //ผ่านเกณฑ์การประเมิน || ไม่ผ่านเกณฑ์การประเมิน
    const [lstScoreSummary, setlstScoreSummary] = useState([]);  //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา

    const [isViewDetails, setisViewDetails] = useState(false);    
    const [ObjDataViewDetails, setObjDataViewDetails] = useState(null);
    //#endregion

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectScoreSummary, { nProjectID : nProjectID }, (result) => { 
            setObjDataProject(result.ObjDataProject);
            setnTotalScore(result.nTotalScore); //คะแนนที่ได้ All
            setnTotalWeightScore(result.nTotalWeightScore); //คะแนนที่ได้ (คิดค่าน้ำหนัก) All
            setisPassCriteriaScore(result.isPassCriteriaScore); //ผ่านเกณฑ์การประเมิน || ไม่ผ่านเกณฑ์การประเมิน
            setlstScoreSummary(result.lstScoreSummary); //ข้อมูลเกณฑ์การให้คะแนน ตามมาตรา
            setisBtnScoreSummary(result.isBtnScoreSummary); //กดปุ่มส่งสรุปคะแนนได้
        });
    }

    const CallTableScoreSummary = useCallback(() => {
        return (
            <TableContainer id='table-ScoreSummary' component={Paper}>
                <Table sx={{ minWidth: 1000 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ minWidth: '180px', width: '180px', alignItems: 'center' }} >
                                {ParseHtml("คณะอนุกรรมการ <br/>")} 
                                <Typography variant='body1' color={'red'}>{"(รอบที่ " + (ObjDataProject?.nCommitteeRoun ?? "") + " ประจำปี " + (ObjDataProject?.nCommitteeRoundYear ? (ObjDataProject?.nCommitteeRoundYear + 543) : "") + ")"}</Typography>
                            </TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนเต็ม <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} >{ParseHtml("คะแนนที่ได้ <br/>(คิดค่าน้ำหนัก)")}</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '200px', width: '200px' }} >หมายเหตุ</TableCell>
                        </TableRow>
                    </TableHead>  
                        {(lstScoreSummary || []).length === 0 ?
                            <StyledTableRow key={`sID_ScoreSummary_`}>
                                <TableCell align="center" colSpan={4} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
                            </StyledTableRow>
                            :
                            <TableBody>
                                {(lstScoreSummary || []).map((iCriteria) => {
                                    return (
                                        <TableRow key={`sID_ScoreSummary_${iCriteria.nCriteriaID}`}>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12} container spacing={1}>
                                                    <Grid item xs={8} md={10}>
                                                        <Typography variant='body2'>{ParseHtml(iCriteria.nNo + ". " + iCriteria.sSubCommitteeName + (iCriteria.sPositionName !== null ? " (" + iCriteria.sPositionName + ")" : ""))}</Typography>
                                                    </Grid>  
                                                    <Grid item xs={4} md={2} container justifyContent={'end'}>
                                                        <Tooltip placement={'right-end'} title={"ดูรายละเอียด"}>
                                                            <ManageSearchIcon 
                                                                id={"BtnViewDetails"} 
                                                                color='primary' 
                                                                onClick={(e)=> {
                                                                    setObjDataViewDetails({
                                                                        lstScoringCriteria: iCriteria.lstScoringCriteria,
                                                                        sSubCommitteeName: iCriteria.sSubCommitteeName,
                                                                    });
                                                                    setisViewDetails(true); 
                                                                }} 
                                                            />
                                                        </Tooltip>
                                                    </Grid>  
                                                </Grid> 
                                            </TableCell>
                                            <TableCell align="center">
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body2'>{iCriteria.nTotalScore !== null ? iCriteria.nTotalScore : ""}</Typography>
                                                </Grid>  
                                            </TableCell>
                                            <TableCell align="center">
                                                <Typography variant='body2'>{iCriteria.nTotalWeightScore !== null ? formatNumber(iCriteria.nTotalWeightScore + "", 2) : ""}</Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Grid item xs={12} md={12}>
                                                    <Typography variant='body2'>{iCriteria.sRemark !== null ? ParseHtml(iCriteria.sRemark + "") : ""}</Typography>
                                                </Grid>  
                                            </TableCell>
                                        </TableRow>                                            
                                    )
                                })}
                                <TableRow key={`sID_ScoreSummary_Sum`}>
                                    <TableCell className='bg-color' align="center" rowSpan={2} colSpan={2} >เฉลี่ยคะแนนที่ได้</TableCell>
                                    <TableCell className='bg-color' align="center" style={{ color: (isPassCriteriaScore ? 'green' : 'red'), }} >{nTotalWeightScore !== null ? formatNumber(nTotalWeightScore + "", 2) : ""}</TableCell>
                                    <TableCell className='bg-color' align="center" style={{ color: (isPassCriteriaScore ? 'green' : 'red'), }} >{nTotalWeightScore !== null ? (isPassCriteriaScore ? EnumProjectStatusFinalScore.PassFinalScore : EnumProjectStatusFinalScore.NotPassFinalScore) : ""}</TableCell>
                                </TableRow>
                            </TableBody>
                        }                    
                </Table>
            </TableContainer>
        );
    }, [lstScoreSummary]);

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}> 
            <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                <Typography variant='h6' color={'#225192'}>ตารางสรุปคะแนนจากคณะอนุกรรมการ</Typography>
            </Grid>
            <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                <Grid item xs={12} md={12} container spacing={1}>
                    <Grid item xs={12} md={1.5}>
                        <Typography variant='body1' fontWeight="bold">ชื่อโครงการ</Typography>
                    </Grid>
                    <Grid item xs={12} md={10.5}>
                        <Typography variant='body1'>{ObjDataProject?.sProjectName}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={1}>
                    <Grid item xs={12} md={1.5}>
                        <Typography variant='body1' fontWeight="bold">หน่วยงาน</Typography>
                    </Grid>
                    <Grid item xs={12} md={10.5}>
                        <Typography variant='body1'>{ObjDataProject?.sUnitTypeName}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={1}>
                    <Grid item xs={12} md={1.5}>
                        <Typography variant='body1' fontWeight="bold">งบประมาณ</Typography>
                    </Grid>
                    <Grid item xs={12} md={10.5} container spacing={1}>
                        <Grid item>
                            <Typography variant='body1'>{formatNumber(ObjDataProject?.nProjectBudget, 2) ?? " - "}</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1' fontWeight="bold">บาท</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant='body1'>{"(" + (ObjDataProject?.sBudgetThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={1}>
                    <Grid item xs={12} md={1.5}>
                        <Typography variant='body1' fontWeight="bold">มาตรา</Typography>
                    </Grid>
                    <Grid item xs={12} md={10.5}>
                        <Typography variant='body1'>{ObjDataProject?.sSectionName}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
                <Divider style={{ color: "#212836" }} />
            </Grid>      
            <Grid item xs={12} md={12}>
                <CallTableScoreSummary />                  
            </Grid>    
            <Grid item xs={12} md={12}>
                <ModalScoringCriteria isOpen={isViewDetails} setIsOpen={setisViewDetails} ObjData={ObjDataViewDetails} />    
            </Grid>    
        </Grid>       
    )
}
export default ProjectScoreSummary;